import { FC, ChangeEvent, RefObject } from 'react';
import { useTranslation } from 'react-i18next';
import { LanguageCode, languageCodes } from '../../../../i18n/language.ts';
import styles from './LanguageDropdown.module.scss';

/**
 * Props for the LanguageDropdown component.
 */
interface LanguageDropdownProps {
    tabIndex: number;
    selectRef: RefObject<HTMLSelectElement | null>;
}

const LanguageDropdown: FC<LanguageDropdownProps> = (props) => {
    const {
        tabIndex,
        selectRef
    } = props;
    
    const { 
        i18n
    } = useTranslation();
    
    const {
        language,
        changeLanguage
    } = i18n;

    /**
     * Change the language of the application based on the selected option.
     * @param {ChangeEvent<HTMLSelectElement>} ev The change event.
     * @returns {void}
     */
    const handleChange = (ev: ChangeEvent<HTMLSelectElement>): void => {
        const selectedLanguageCode = ev.target.value as LanguageCode;
        changeLanguage(selectedLanguageCode);
    };

    return (
        <select
            ref={selectRef}
            tabIndex={tabIndex}
            value={language}
            onChange={handleChange}
            name="languageCode"
            className={styles.languageDropdown}
        >
            {languageCodes
                .map((languageCode) => (
                    <option
                        key={languageCode}
                        value={languageCode}
                    >
                        {languageCode.toUpperCase()}
                    </option>
                ))}
        </select>
    );
};
export default LanguageDropdown;